import * as React from "react"

import Link from "#Components/shared/link"
import Icon from "#React/ui/Icon"
import { cn } from "#Utils/cn"

type BreadcrumbsProps = React.ComponentPropsWithoutRef<"ul">

type BreadcrumbsItemProps = React.ComponentPropsWithoutRef<"li"> & {
  href?: string
  to?: string
  params?: Record<string, string>
  search?: Record<string, unknown>
}

const Chevron = () => (
  <li className="c-breadcrumbs__chevron" aria-hidden="true">
    <Icon name="far fa-chevron-right" size="xs" tone="secondary" />
  </li>
)

const BreadcrumbsItem = ({ href, to, params, search, children, className, ...rest }: BreadcrumbsItemProps) => (
  <li className={className} {...rest}>
    {href || to ? (
      <Link className="c-breadcrumbs__link" href={href} to={to} params={params} search={search}>
        {children}
      </Link>
    ) : (
      children
    )}
  </li>
)

const Breadcrumbs = ({ children, className, ...rest }: BreadcrumbsProps) => {
  const items = React.Children.toArray(children).filter(React.isValidElement)

  return (
    <ul className={cn("c-breadcrumbs", className)} {...rest}>
      {items.map((child, index) => (
        <React.Fragment key={child.key ?? index}>
          {index > 0 && <Chevron />}
          {child}
        </React.Fragment>
      ))}
    </ul>
  )
}

Breadcrumbs.Item = BreadcrumbsItem

export default Breadcrumbs
